import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AmbassadorProvider } from '@context/context'
import NotificationWrapper from '@corecomponents/notification/NotificationWrapper'

const queryClient = new QueryClient()
const publicEnv = process.env.REACT_APP_PUBLIC_ENVIRONMENT
const release = process.env.REACT_APP_PP_CLIENT_VERSION
const dsnLink = process.env.REACT_APP_SENTRY_DSN

Sentry.init({
  dsn: dsnLink,
  release: `pw-ambassador@${release}`,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  environment: publicEnv,
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 10% of the transactions
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const AppWithProfiler = Sentry.withProfiler(App)

root.render(
  <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      <BrowserRouter>
        <AmbassadorProvider>
          <NotificationWrapper />
          <AppWithProfiler />
        </AmbassadorProvider>
      </BrowserRouter>
    </React.StrictMode>
  </QueryClientProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
